import { IconWrapper, SquareButton } from './ToolbarOptions.style';
import { ReactComponent as EditIcon } from 'icons/icon-pencil.svg';

export const EditButton = ({ item }) => {
  return (
    <SquareButton
      onClick={() => {
        item.onClick();
      }}
      {...item.otherProps}
    >
      <IconWrapper>
        <EditIcon data-pw="edit" />
      </IconWrapper>
    </SquareButton>
  );
};
